import { memo, useMemo, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Divider, Drawer, Stack, useMediaQuery } from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import { openDrawer } from 'store/slices/menu';
import { useDispatch, useSelector } from 'store';
import { drawerWidth } from 'store/constant';
import Chip from 'ui-component/extended/Chip';
import config from 'config';
import LocalizationMenu from '../Header/LocalizationSection/LocalizationMenu';
import ProfileMenu from '../Header/ProfileSection/ProfileMenu';
import CustomDialog from 'ui-component/extended/CustomDialog';
import VersionDetails from './VersionDetails';
import useAuth from 'hooks/useAuth';


// ==============================|| SIDEBAR DRAWER ||============================== //

interface SidebarProps {
    window?: Window;
}

const Sidebar = ({ window }: SidebarProps) => {
    const theme = useTheme();
    const { user } = useAuth();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

    const dispatch = useDispatch();
   const [showVersionDetailed,setShowVersionDetailed] = useState(false);
    const { drawerOpen } = useSelector((state) => state.menu);

    const logo = useMemo(
        () => (
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <Box sx={{ display: 'flex', p: 2, mx: 'auto' }}>
                    <LogoSection />
                </Box>
            </Box>
        ),
        []
    );

    const drawer = useMemo(
        () => (
            <PerfectScrollbar
                component="div"
                style={{
                    height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 68px)',
                    paddingLeft: '16px',
                    paddingRight: '16px'
                }}
            >
                <Divider sx={{ mt: 1, mb: 1.25 }} />
                <MenuList />
                <LocalizationMenu />
                <Divider sx={{ mt: 1, mb: 1.25 }} />
                <ProfileMenu />
                <Divider sx={{ mt: 1, mb: 1.25 }} />
               
                <Stack direction="row"  justifyContent="center" sx={{ mb: 2 }}>
                   <Chip 
                   onClick={()=> {user?.isSystemAdmin && setShowVersionDetailed(true)}} 
                   label={`version num ${config.version_num}`} 
                   disabled chipcolor="secondary" size="small" sx={{ cursor: 'pointer' }} />
                </Stack>
            </PerfectScrollbar>
        ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [matchUpMd]
    );

    const container = window !== undefined ? () => window.document.body : undefined;

    return (
        <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="mailbox folders">
            <Drawer
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={() => dispatch(openDrawer(!drawerOpen))}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        background: theme.palette.background.default,
                        color: theme.palette.text.primary,
                        borderRight: 'none',
                        [theme.breakpoints.up('md')]: {
                            top: '88px'
                        }
                    }
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                {drawerOpen && logo}
                {drawerOpen && drawer}
            </Drawer>
            <CustomDialog size='sm'
            headerText="What's new?"
            showHeaderCloseButton
            
            openDialog={showVersionDetailed} 
            onClose={()=>{setShowVersionDetailed(false)}}>
                 <VersionDetails />
            </CustomDialog>
        </Box>
    );
};

export default memo(Sidebar);
